import { flow, types, getEnv } from 'mobx-state-tree'

import { Tournament } from './'

const Tournaments = types
  .model('TournamentsModel', {
    items: types.optional(types.map(Tournament), {}),
  })
  .actions((self) => {
    const {
      services: { tournamentService },
    } = getEnv(self)

    return {
      // TODO: temp method and workaround simultanously
      add(tournament) {
        if (!tournament) {
          return null
        }

        self.items.set(tournament.id, tournament)

        return self.items.get(tournament?.id)
      },

      loadOne: flow(function* (id) {
        if (!self.items.has(id)) {
          const event = yield tournamentService.get(id)
          return self.add(event)
        }

        return self.items.get(id)
      }),

      load: flow(function* (params) {
        const response = yield tournamentService.query(params)
        const tournaments = response.content.map((tournament) =>
          self.add(tournament)
        )

        return {
          response,
          tournaments,
        }
      }),

      loadUpcoming: flow(function* (params) {
        const response = yield tournamentService.getTournamentsUpcomings(params)
        const tournaments = response.content.map((tournament) =>
          self.add(tournament)
        )

        return {
          response,
          tournaments,
        }
      }),

      loadAll: flow(function* (params) {
        const response = yield tournamentService.getAllTournaments(params)
        const tournaments = response.content.map((tournament) =>
          self.add(tournament)
        )

        return {
          response,
          tournaments,
        }
      }),
    }
  })

export const TournamentsRoot = types.model('TournamentsRoot', {
  tournaments: types.optional(Tournaments, {}),
})
